import { makeAutoObservable } from "mobx";
import {
  GET,
  PUT,
  PATCH,
  POST,
  // POST_USER,
  GET_USER,
  // PUT_USER,
} from "../apis/apis";

class ReportStore {
  constructor({ errStore }) {
    makeAutoObservable(this);
    this.errStore = errStore;
  }

  reports = [];
  reportDetails = null;
  isReportModalOpen = false;

  setReports = (value) => {
    this.reports = value;
  };

  setReportDetails = (value) => {
    this.reportDetails = value;
  };

  setIsReportModalOpen = (value) => {
    this.isReportModalOpen = value;
  };

  setToken = (value) => {
    this.token = value;
  };

  getToken = () => {
    this.token = JSON.parse(localStorage.getItem("dafne-user-data")).token;
  };

  GetReports = () => {
    this.errStore.setLoading(true);
    GET_USER(`/report`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.setReports(data);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetReportById = (id) => {
    this.errStore.setLoading(true);
    GET_USER(`/report/${id}`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.setReportDetails(data);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  UpdateReportById = (id, values) => {
    this.errStore.setLoading(true);
    return PUT(`/report/${id}`, values)
      .then((data) => {
        this.errStore.setMessage("");
        this.reports = this.reports
          .map((report) => {
            if (report.id === data.id && data.action !== "removed") {
              return data;
            } else if (report.id === data.id && data.action === "removed") {
              return null;
            }
            return report;
          })
          .filter((report) => report !== null);
        this.setReportDetails(data);
        this.setIsReportModalOpen(false);
        return data;
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
        throw error;
      })
      .finally(() => {
        this.errStore.setLoading(false);
      });
  };

  PatchReportById = (id, values) => {
    this.errStore.setLoading(true);
    PATCH(`/report/${id}`, values)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.setReportDetails(data);
        this.setIsReportModalOpen(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  CreateReport = (itemId, values) => {
    this.errStore.setLoading(true);
    POST(`/report/create/${itemId}`, values)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.GetReports();
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };
}

export default ReportStore;
